module.exports = __webpack_public_path__ + "img/toothpaste-productp.5deaef9c.png";